import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from "react-i18next";

import Select from './Select';

import { useAuth } from '../../../hooks/useAuth';
import { Storage } from '../../../utils/Storage';

import { selectUserLocations } from '../../../store/locationsSlice';
import { getUserWarehouseLocations } from '../../../store/locationsSlice';
import { setLocation, selectLocation, setCategory } from '../../../store/filtersSlice';
import { getCategories } from '../../../store/categoriesSlice';
import { getReturnKey } from '../../../store/cartSlice';
import { getSettings, selectAllowMultiLocationCart, selectLoginInCheckout, selectWarehouseLocations } from '../../../store/settingsSlice';

export default function SelectLocation(props) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { t } = useTranslation();
    const { token } = useAuth();
    const { sx, disabled = false } = props;
    const userLocations = useSelector(selectUserLocations);
    const warehouseLocations = useSelector(selectWarehouseLocations);
    const loginInCheckout = useSelector(selectLoginInCheckout);
    const allowMultiLocationCart = useSelector(selectAllowMultiLocationCart);
    const location = useSelector(selectLocation);
    const shouldUseWarehouseLocations = (loginInCheckout || allowMultiLocationCart) && userLocations.length === 0;
    const selectableLocations = shouldUseWarehouseLocations ? warehouseLocations : userLocations;

    useEffect(() => {
        if (token && userLocations.length === 0) {
            dispatch(getUserWarehouseLocations());
        }
    }, [dispatch, token, userLocations.length]);

    const handleLocationChange = (event) => {
        // Also save the new location id in local storage
        Storage.setLocationId(event.target.value);
        dispatch(setLocation(event.target.value));

        dispatch(getSettings());

        dispatch(getCategories());
        dispatch(getReturnKey());

        dispatch(setCategory("X"));
        navigate("/items");
    };

    return (
        <Select
            sx={sx}
            id="location"
            label={t("location.select.label")}
            value={location}
            onChange={handleLocationChange}
            options={[{id: "0", name: "bitte auswählen..."}, ...selectableLocations]}
            disabled={disabled}
        />
    );
}
